export const RoomTypeTranslationKeys: Record<string, string> = {
	'7cf10dd2-b761-4285-a360-dac725927477': 'generic',
	'0788f250-8edb-4aa0-a875-83f4f16c1f98': 'bedroom',
	'd1b02646-f29c-458d-89e3-e3fec902b63a': 'common_room',
	'cffcf025-74c5-4dd1-9b1b-76434626ef50': 'hallway',
	'218e9871-aad1-4b6d-94e8-c641f10eddff': 'kitchen',
	'f3968417-8c9c-444c-ac49-8e4ef4995559': 'meeting_room',
	'6f0ef85b-6d42-4dda-8ccc-b454a59a01a1': 'office',
	'82a5ed91-037e-4123-bc92-8db779516067': 'other',
	'0af40432-6404-484b-892f-c95ff1e91652': 'storage',
	'ecadee80-2de5-45f2-9966-71f7bb6d847e': 'utilities',
	'f1c55054-ecb2-4059-8406-185206cc7225': 'wc',
};
